import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstanse";
import { enum_api_uri } from "../utils/enum";

interface Comment {
    c_content: string;
    c_name: string;
    c_wdate: string;
}

export interface RequestViewResult {
    list_no: number;
    category: string;
    subject: string;
    bl_no: string;
    company: string;
    contents: string;
    bigo: string;
    mobile: string;
    comment_list: Comment[];
}

export interface RequestViewResponse {
    statusCode: number;
    message: string;
    data: RequestViewResult;
}

export const useGetRequestView = (list_no: string): UseQueryResult<RequestViewResult, Error> => {
    return useQuery({
        queryKey: ["useGetRequestView", list_no],
        queryFn: async () => {
            const { data } = await axiosInstance.get<RequestViewResponse>(`${enum_api_uri.get_request_view}?list_no=${list_no}`);
            return data.data;
        },
        enabled: !!list_no,
    });
};
